import { PageHeader } from "@safeplate/ui";
import { Link, useNavigate } from "@tanstack/react-router";
import { ChevronRight, LifeBuoy } from "lucide-react";
import { useEffect } from "react";

import { settingsHelp, settingsSections } from "../shell/navigation.js";
import { useShell } from "../shell/shell-context.js";
import { sectionIcons } from "./settings-layout.js";

const DESKTOP_QUERY = "(min-width: 1024px)";

export function SettingsIndex() {
  const shell = useShell();
  const navigate = useNavigate();

  useEffect(() => {
    if (globalThis.matchMedia?.(DESKTOP_QUERY).matches) {
      void navigate({ replace: true, to: "/settings/notifications" });
    }
  }, [navigate]);

  return (
    <div className="lg:hidden">
      <PageHeader className="mb-5" title="Settings" />
      <ul className="divide-y divide-stone-200 overflow-hidden rounded-2xl border border-stone-200 bg-surface">
        {settingsSections(shell.activeRole).map((section) => {
          const Icon = sectionIcons[section.icon];
          return (
            <li key={section.key}>
              <Link
                className="flex min-h-14 items-center gap-3 px-4 text-sm font-semibold text-stone-900 hover:bg-stone-50"
                to={section.to}
              >
                <Icon
                  aria-hidden="true"
                  className="size-5 shrink-0 text-emerald-800"
                />
                <span className="flex-1">{section.label}</span>
                <ChevronRight
                  aria-hidden="true"
                  className="size-4 text-stone-400"
                />
              </Link>
            </li>
          );
        })}
        <li>
          <a
            className="flex min-h-14 items-center gap-3 px-4 text-sm font-semibold text-stone-900 hover:bg-stone-50"
            href={settingsHelp.href}
            rel="noreferrer"
            target="_blank"
          >
            <LifeBuoy
              aria-hidden="true"
              className="size-5 shrink-0 text-emerald-800"
            />
            <span className="flex-1">{settingsHelp.label}</span>
            <span className="text-xs font-normal text-stone-500">
              {settingsHelp.address}
            </span>
          </a>
        </li>
      </ul>
    </div>
  );
}
